import { ListItem } from './interfaces'

export interface PartitionFilterOptionsResult {
  visible: ListItem[]
  hasQuery: boolean
}

export interface PartitionSelectedFilterOptionsResult {
  selected: ListItem[]
  unselected: ListItem[]
}

export const partitionFilterOptions = (
  options: ListItem[],
  query: string
): PartitionFilterOptionsResult => {
  const trimmed = query.trim().toLowerCase()
  if (!trimmed) {
    return { visible: options, hasQuery: false }
  }

  const visible = options.filter((option) =>
    option.label.toLowerCase().includes(trimmed)
  )

  return { visible, hasQuery: true }
}

export const partitionSelectedFilterOptions = (
  options: ListItem[]
): PartitionSelectedFilterOptionsResult => ({
  selected: options.filter((option) => option.active),
  unselected: options.filter((option) => !option.active),
})
